import { useState } from "react";

import Electrical_one from "../../../assets/images/1500EFIImg/1500Ewithnewdoors1.png";
import Electrical_two from "../../../assets/images/1500EFIImg/1500Ewithnewdoors4.jpg";
import Electrical_three from "../../../assets/images/1500EFIImg/1500E-4newdoors&AC2(1).jpg";
import Electrical_Four from "../../../assets/images/1500EFIImg/1500Enewdoors8.jpg";
import Electrical_Five from "../../../assets/images/1500EFIImg/ElectricTuatarawithAC.jpg";
import Electrical_Six from "../../../assets/images/1500EFIImg/ACon1500E(Top).jpg";
import Electrical_Seven from "../../../assets/images/1500EFIImg/AConeTuatara1.jpeg";
import Electrical_Eight from "../../../assets/images/1500EFIImg/AConeTuatara2.jpeg";

const images = [
  Electrical_one,
  Electrical_two,
  Electrical_three,
  Electrical_Four,
  Electrical_Five,
  Electrical_Six,
  // Electrical_Seven,
  Electrical_Eight,
];

const NZElectricModels = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  // Tooltip
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);

  const openSlider = (i) => {
    setIndex(i);
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeSlider = () => {
    setOpen(false);
    document.body.style.overflow = "auto";
  };

  const prevImg = () => setIndex((i) => (i === 0 ? images.length - 1 : i - 1));

  const nextImg = () => setIndex((i) => (i === images.length - 1 ? 0 : i + 1));

  return (
    <>
      <div className="bg-white">
        <div className="custom-container px-[20px] sm:px-[30px] text-start mx-auto">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 justify-items-center">
              {/* -------- IMAGE 1 -------- */}
              <div
                onClick={() => openSlider(0)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Electrical_one}
                  alt="Electric Tuatara 1500E utility vehicle front three-quarter view"
                  className="w-[98%] h-[98%] object-contain scale-[1.5] mt-[-50px]"
                />
              </div>

              {/* -------- IMAGE 2 -------- */}
              <div
                onClick={() => openSlider(1)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Electrical_two}
                  alt="Electric Tuatara 1500E front view with doors open"
                  className="w-[98%] h-[98%] object-contain scale-[1.1]"
                />
              </div>

              {/* -------- IMAGE 3 -------- */}
              <div
                onClick={() => openSlider(2)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Electrical_three}
                  alt="Electric Tuatara 1500E rear three-quarter view with cargo tray"
                  className="w-[98%] h-[98%] object-contain scale-[1.06]"
                />
              </div>

              {/* -------- IMAGE 4 -------- */}
              <div
                onClick={() => openSlider(3)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Electrical_Four}
                  alt="Electric Tuatara 1500E rear view with open doors"
                  className="w-[98%] h-[98%] object-contain scale-[1.1]"
                />
              </div>

              {/* -------- IMAGE 5 -------- */}
              <div
                onClick={() => openSlider(4)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Electrical_Five}
                  alt="Electric Tuatara 1500E utility vehicle outdoor real-world view"
                  className="w-[98%] h-[98%] object-contain scale-[1.36] mb-[40px]"
                />
              </div>

              {/* -------- IMAGE 6 -------- */}
              <div
                onClick={() => openSlider(5)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Electrical_Six}
                  alt="Electric Tuatara 1500E roof-mounted air conditioning unit"
                  className="w-[98%] h-[98%] object-contain scale-[1.37] mr-[55px]"
                />
              </div>

              {/* -------- IMAGE 7 -------- */}
              {/* <div
                onClick={() => openSlider(6)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img src={Electrical_Seven} className="w-[98%] h-[98%] object-contain scale-[1.28]" />
              </div> */}

              {/* -------- IMAGE 8 -------- */}
              <div
                onClick={() => openSlider(6)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Electrical_Eight}
                  alt="Electric Tuatara 1500E cabin ceiling air vents and controls"
                  className="w-[98%] h-[98%] object-contain scale-[1.36] mr-[70px]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- FULL SCREEN SLIDER ---------- */}
      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[99999]"
          onClick={closeSlider}
        >
          <div className="relative" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={closeSlider}
              className="absolute top-[-50px] right-0 text-white text-5xl"
            >
              ×
            </button>

            <button
              onClick={prevImg}
              className="absolute left-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl"
            >
              ‹
            </button>

            <img
              src={images[index]}
              className="max-h-[80vh] max-w-[90vw] object-contain bg-white rounded-lg shadow-xl"
            />

            <button
              onClick={nextImg}
              className="absolute right-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl"
            >
              ›
            </button>
          </div>
        </div>
      )}

      {/* Tooltip */}
      {showTooltip && (
        <div
          className="fixed z-[99999] bg-black text-white text-[13px] px-3 py-1 rounded-md pointer-events-none"
          style={{ top: tooltipPos.y + 15, left: tooltipPos.x + 15 }}
        >
          Click here to expand
        </div>
      )}
    </>
  );
};

export default NZElectricModels;
